const PERMISSION_EMPLOYEE_EXPORT_EMPLOYEE_LIST ="employee_export_employee_list";
const PERMISSION_ELOG_VIEW_FILES = "elog_view_files";
const PERMISSION_ELOG_APPROVE_REJECT = "elog_approve_reject";
const PERMISSION_CLAIM_VIEW_ATTACHMENT = "claim_view_attachment";
const PERMISSION_VIEW_ANALYTICS = "view_analytics";
const PERMISSION_ADD_PARTNER_HR = "add_partner_hr";
const PERMISSION_DOWNLOAD_APPROVED_ELOG = "download_approved_elogs";
const PERMISSION_REQUEST_PRE_SIGNED_ELOG = "request_pre_signed_elog";
const PERMISSION_DOWNLOAD_CLAIM_DATA = "download_claims_data";
const PERMISSION_MASTER_ADMIN = "master_admin";
const PERMISSION_VIEW_HR_PARTNER_ACCOUNT_LIST = "view_hr_partner_account_list";
const PERMISSION_EDIT_HR_PARTNER_ACCOUNT_LIST = "edit_hr_partner_accounts";
const PERMISSION_SEE_ALL_BROKER_ACCOUNTS = "see_all_broker_accounts";
const PERMISSION_VIEW_HR_PARTNER_CREATION_EDIT_LOG = "view_hr_partner_creation_edit_logs";
const PERMISSION_SEE_UNIVERSAL_BROKER_ACCOUNT = "see_universal_broker_account";
const PERMISSION_VIEW_HR_CREATED_CLAIMS = "view_hr_created_claims";
const PERMISSION_VIEW_PRE_SIGNED_ELOG = "view_pre_signed_elog";
const PERMISSION_HR_CLAIM_VIEW_ATTACHMENT = "hr_claim_view_attachment";
const PERMISSION_EDIT_HR_CREATED_CLAIMS = "edit_hr_created_claims";

module.exports = {
   PERMISSION_EMPLOYEE_EXPORT_EMPLOYEE_LIST,
   PERMISSION_ELOG_VIEW_FILES,
   PERMISSION_ELOG_APPROVE_REJECT,
   PERMISSION_CLAIM_VIEW_ATTACHMENT,
   PERMISSION_VIEW_ANALYTICS,
   PERMISSION_ADD_PARTNER_HR,
   PERMISSION_DOWNLOAD_APPROVED_ELOG,
   PERMISSION_REQUEST_PRE_SIGNED_ELOG,
   PERMISSION_DOWNLOAD_CLAIM_DATA,
   PERMISSION_MASTER_ADMIN,
   PERMISSION_VIEW_HR_PARTNER_ACCOUNT_LIST,
   PERMISSION_EDIT_HR_PARTNER_ACCOUNT_LIST,
   PERMISSION_SEE_ALL_BROKER_ACCOUNTS,
   PERMISSION_VIEW_HR_PARTNER_CREATION_EDIT_LOG,
   PERMISSION_SEE_UNIVERSAL_BROKER_ACCOUNT,
   PERMISSION_VIEW_HR_CREATED_CLAIMS,
   PERMISSION_VIEW_PRE_SIGNED_ELOG,
   PERMISSION_HR_CLAIM_VIEW_ATTACHMENT,
   PERMISSION_EDIT_HR_CREATED_CLAIMS
};
